import { Stack } from '@mui/material';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { FundingRatesPage } from '../features/funding_rates/funding_rates.tsx';
import useAppStore from '../store/rootStore.ts';
import { createPageBackgroundSx } from '../styles/pageBackground.ts';

export const Route = createFileRoute('/funding-rates')({
  component: FundingRatesRouteComponent,
  beforeLoad: () => {
    if (!useAppStore.getState().config?.features.fundingRatesEnabled) {
      throw redirect({ to: '/trade', replace: true });
    }
  },
});

const fundingRatesPageSx = createPageBackgroundSx();

function FundingRatesRouteComponent() {
  return (
    <Stack sx={fundingRatesPageSx}>
      <FundingRatesPage />
    </Stack>
  );
}
